const CheckIcon = ({ className }) => (
  <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M15 27.5625C23.2153 27.5625 29.875 21.4904 29.875 14C29.875 6.50964 23.2153 0.4375 15 0.4375C6.78477 0.4375 0.125 6.50964 0.125 14C0.125 21.4904 6.78477 27.5625 15 27.5625ZM23.0401 10.9562C23.6823 10.2937 23.6477 9.25324 22.9628 8.63219C22.2777 8.01113 21.202 8.04471 20.5598 8.70716L13.1921 16.308L9.32944 12.9873C8.6277 12.384 7.55317 12.4451 6.92942 13.1238C6.30567 13.8025 6.36887 14.8417 7.0706 15.445L11.3457 19.1202C12.4934 20.107 14.2448 20.0299 15.2951 18.9464L23.0401 10.9562Z" fill="#1DD6CE" />
  </svg>

);

export default CheckIcon;
